import {APP_INITIALIZER, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {Store} from '@ngrx/store';

import {HeaderComponent} from './header/header.component';
import {HomeComponent} from './home/home.component';
import {AppRoutingModule} from '../app-routing.module';
import {SettingsService} from './settings.service';
import {ErrorComponent} from '../error/error.component';
import {ErrorInterceptor} from '../error/error.interceptor';
import {AuthInterceptor} from '../auth/auth.interceptor';
import {AuthGuard} from '../auth/auth-guard.service';
import {AnonymousGuard} from '../auth/anonymous-guard.service';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {UserModule} from '../user/user.module';
import {ProfileModule} from '../profile/profile.module';
import {PaymentModule} from '../payment/payment.module';
import {DemoModule} from '../demo/demo.module';
import {EffectsModule} from '@ngrx/effects';
import {UserEffects} from '../user/store/user.effects';
import {ProfileEffects} from '../profile/store/profile.effects';
import {PaymentEffects} from '../payment/store/payment.effects';
import {PostEffects} from '../profile/post/store/post.effects';
import {DemoEffects} from '../demo/store/demo.effects';
import {Cookie} from '../helper/cookie';
import {NgClickOutsideDirective} from 'ng-click-outside2';
import {ProfileLimitGuard} from '../profile/profile-limit-guard.service';
import {PostLimitGuard} from '../profile/post-limit-guard.service';
import {CertificateEffects} from '../profile/certificate/store/certificate.effects';
import {TrialEffects} from '../profile/trial/store/trial.effects';

import * as fromApp from '../store/app.reducers';
import * as UserActions from '../user/store/user.actions';
import {CompareModule} from '../compare/compare.module';
import {CompareEffects} from '../compare/store/compare.effects';
import {SettingModule} from '../setting/setting.module';
import {SettingEffects} from '../setting/store/setting.effects';
import {SpecialOfferModule} from '../special-offer/special-offer.module';
import {SpecialOfferEffects} from '../special-offer/store/special-offer.effects';


@NgModule({
  declarations: [
    HeaderComponent,
    HomeComponent,
    ErrorComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CommonModule,
    UserModule,
    ProfileModule,
    PaymentModule,
    DemoModule,
    CompareModule,
    SettingModule,
    EffectsModule.forFeature([
      UserEffects, ProfileEffects, PaymentEffects, PostEffects, DemoEffects, CertificateEffects, TrialEffects,
      CompareEffects, SettingEffects, SpecialOfferEffects
    ]),
    NgClickOutsideDirective,
    SpecialOfferModule
  ],
  exports: [
    HeaderComponent,
    AppRoutingModule
  ],
  providers: [
    SettingsService,
    AuthGuard,
    ProfileLimitGuard,
    PostLimitGuard,
    AnonymousGuard,
    Cookie,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (store: Store<fromApp.AppState>, cookie: Cookie) => {
        if (cookie.getCookie('auditor-user-id')) {
          return () => {
            store.dispatch(new UserActions.GetActualUser());
          };
        }
        if (!cookie.getCookie('auditor-user-id') && cookie.getCookie('auditor-uid')) {
          return () => {
            store.dispatch(new UserActions.GetActualUserByUid());
          };
        }
        return () => {};
      },
      multi: true,
      deps: [Store, Cookie]
    }
  ]
})
export class CoreModule {}
